var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"saveExercise":_vm.saveExercise,"refItems":_vm.refItems,"exercise":_vm.exercise,"doc":_vm.doc})],2)}
var staticRenderFns = []

export { render, staticRenderFns }